import { enClarity } from './en-clarity';
import { enSector } from './en-sector';
import { enWeapons } from './en-weapons';
import { enWorld } from './en-world';
import { enShop } from './en-shop';
import { enMaps } from './en-maps';
import { enHangar } from './en-hangar';
import { enPolish } from './en-polish';
/** English strings — the reference dictionary. Keys missing in other langs fall back here. */
export const en = {
  ...enClarity,
  ...enWeapons,
  ...enWorld,
  ...enShop,
  ...enMaps,
  ...enHangar,
  ...enSector,
  ...enPolish,
  // Settings
  'settings.title': 'SETTINGS',
  'settings.movement': 'Movement Mode',
  'settings.movement.world': 'World-relative (twin-stick)',
  'settings.movement.nose': 'Nose-relative (forward = aim)',
  'settings.autoaim': 'Auto-aim',
  'settings.sound': 'Sound',
  'settings.language': 'Language',
  'settings.on': 'ON',
  'settings.off': 'OFF',
  'settings.fullscreen': 'Fullscreen',
  'settings.back': '◀ BACK',
  'settings.hint.keyboard': '↑/↓ select    ←/→ or Space change    Esc back',
  'settings.hint.gamepad': '↑/↓ select    ←/→ or Ⓐ change    Ⓑ/Start back',
  'settings.hint.touch': 'Tap an option to change it',

  // Fullscreen prompt (asked once)
  'fs.title': 'Play in fullscreen?',
  'rotate.title': 'Rotate your device — Atlas: Boss Rush plays landscape',
  'xbox.gamepadHint': 'Controller not detected. Open the Edge address-bar menu and switch this site to GAMEPAD control, then press any button.',
  'fs.yes': 'YES',
  'fs.no': 'NO',

  // Shop
  'shop.title': 'UPGRADE',
  'shop.rerollBtn': 'REROLL',
  'shop.continueBtn': 'CONTINUE ▶',
  'shop.next': 'NEXT ARENA',
  'shop.nextWaves': '{n} WAVES FIRST',
  'gem.yellow': 'GEM',
  'gem.red': 'CORE',
  'shop.collectionTitle': 'CARD COLLECTION',
  'shop.level': 'LV {n}',

  // Ship status panel (Brotato-style stat sheet)
  'statp.title': 'SHIP STATUS',
  'statp.damage': 'DAMAGE',
  'statp.firerate': 'FIRE RATE',
  'statp.bullet': 'BULLET DMG',
  'statp.bulletrate': 'BULLET RATE',
  'statp.plasma': 'PLASMA DMG',
  'statp.plasmarate': 'PLASMA RATE',
  'statp.laser': 'LASER DMG',
  'statp.laserrate': 'LASER RATE',
  'statp.bomb': 'BOMB DMG',
  'statp.bombrate': 'BOMB RATE',
  'statp.critchance': 'CRIT CHANCE',
  'statp.critdamage': 'CRIT DAMAGE',
  'statp.projspeed': 'PROJ SPEED',
  'statp.range': 'FIRE RANGE',
  'statp.supershot': 'SUPERSHOT DMG',
  'statp.fan': 'SUPERSHOT FAN',
  'statp.tier': 'GUN TIER',
  'statp.maxhp': 'MAX HP',
  'statp.shieldstart': 'START ARMOR',
  'statp.rerolldisc': 'REROLL PRICE',
  'statp.reduction': 'DMG REDUCTION',
  'statp.aegis': 'AEGIS LINK',
  'statp.armorkill': 'ARMOR / BOSS',
  'statp.iframes': 'HIT GUARD',
  'statp.speed': 'MOVE SPEED',
  'statp.dashcd': 'DASH COOLDOWN',
  'statp.magnet': 'MAGNET',
  'statp.greed': 'GEM GAIN',
  'statp.discount': 'SHOP PRICES',
  'statp.regen': 'ARENA REPAIR',
  'statp.lifesteal': 'LIFE STEAL',
  'statp.cargo': 'CARGO BAYS',
  'statp.energy': 'ENERGY / HIT',

  // Weapon tooltip
  'wstat.rate': 'FIRE RATE',
  'wstat.dps': 'DPS',
  'wstat.behavior': 'TYPE',

  // Confirm dialog (reusable)
  'confirm.yes': 'CONFIRM',
  'confirm.no': 'CANCEL',
  'confirm.deleteSave': 'Delete this save? The collection and all progress in this slot are lost.',

  // HUD / flow
  'hud.portalOpen': 'PORTAL OPEN',
  'hud.wave': 'WAVE {n}/{m}',
  'hud.bossIncoming': 'BOSS INCOMING',
  'hud.levelUp': 'LEVEL UP — LV {n}',

  // Title screen
  'title.continue': 'CONTINUE',
  'title.settings': 'SETTINGS',
  'title.tag': 'sector boss rush',
  'title.calibration': 'GAMEPAD TEST',
  'calib.title': 'GAMEPAD CALIBRATION — wiggle everything',
  'calib.exit': 'Ⓑ / Esc — back',
  'calib.nopad': 'No gamepad detected — press any button on the pad',
  'calib.interpreted': 'GAME READS THIS',
  'title.slot': 'SLOT {n}',
  'title.slotEmpty': 'EMPTY — START NEW GAME',
  'title.deleteHint': '✕ / Ⓧ — delete the selected save',
  'title.back': '◀ BACK',
  'title.pickContinue': 'CONTINUE — PICK A SLOT',
  'title.seed': 'SEED: {v}',
  'title.seedRandom': 'RANDOM',
  'title.seedPrompt': 'Seed (leave empty for random)',
  'title.overwrite': 'OVERWRITE',
  'gameover.title': 'SHIP DESTROYED',
  'gameover.burnTitle': 'Burn {n} more to fly again',
  'gameover.extraHint': 'Extra burns repair ARMOR',
  'gameover.armorBonus': '+{n} ARMOR',
  'gameover.burned': 'BURNED',
  'gameover.weaponTag': 'WEAPON',
  'gameover.continueBtn': 'FLY AGAIN ▶',
  'gameover.menuBtn': 'MAIN MENU',
  'gameover.newRecord': '★ NEW RECORD ★',
  'gameover.seed': 'Seed: {seed}',
  'gameover.totalRuns': 'TRY #{n}',
  'gameover.hint.keyboard': '←/→ select    Space burn / confirm',
  'gameover.hint.gamepad': '←/→ select    Ⓐ burn / confirm',
  'gameover.hint.touch': 'Tap a card to burn it',

  // Run stats
  'stats.timeAlive': 'Time survived',
  'stats.bossKills': 'Bosses destroyed',
  'stats.droneKills': 'Drones destroyed',
  'stats.gemsCollected': 'Gems collected',
  'stats.bulletsFired': 'Shots fired',
  'stats.damageDealt': 'Damage dealt',
  'stats.arenasCleared': 'Arenas cleared',

  // Weapons
  'weapon.autocannon': 'Autocannon',
  'weapon.smg': 'Scrap SMG',
  'weapon.heavy_cannon': 'Heavy Cannon',
  'weapon.plasma_orb': 'Plasma Orb',
  'weapon.plasma_lance': 'Plasma Lance',
  'weapon.needle_laser': 'Needle Laser',
  'weapon.pulse_laser': 'Pulse Laser',
  'weapon.mortar': 'Mortar',
  'weapon.rocket': 'Rocket Pod',
  'weapon.homing_missile': 'Seeker Missile',

  // Cards
  'card.damage.name': 'Heavy Rounds',
  'card.damage.desc': 'All damage +4%',
  'card.firerate.name': 'Rapid Loader',
  'card.firerate.desc': 'ALL weapon categories: fire rate +5%',
  'card.catbullet.name': 'Ballistics Lab',
  'card.catbullet.desc': 'BULLET weapons: damage +5%',
  'card.catplasma.name': 'Plasma Harmonics',
  'card.catplasma.desc': 'PLASMA weapons: damage +5%',
  'card.catlaser.name': 'Optics Array',
  'card.catlaser.desc': 'LASER weapons: damage +5%',
  'card.catbomb.name': 'Demolitions Kit',
  'card.catbomb.desc': 'BOMB weapons: damage +5%',
  'card.ratebullet.name': 'Belt Feeder',
  'card.ratebullet.desc': 'BULLET weapons: fire rate +5%',
  'card.rateplasma.name': 'Coil Cycler',
  'card.rateplasma.desc': 'PLASMA weapons: fire rate +5%',
  'card.ratelaser.name': 'Pulse Capacitor',
  'card.ratelaser.desc': 'LASER weapons: fire rate +5%',
  'card.ratebomb.name': 'Quick Loader',
  'card.ratebomb.desc': 'BOMB weapons: fire rate +5%',
  'card.range.name': 'Long-Bore Coils',
  'card.range.desc': 'Fire range +8%',
  'card.critchance.name': 'Target Analyzer',
  'card.critchance.desc': 'Crit chance +3%',
  'card.critdamage.name': 'Rupture Charge',
  'card.critdamage.desc': 'Crit damage +15%',
  'card.projspeed.name': 'Velocity Coils',
  'card.projspeed.desc': 'Projectile speed +6%',
  'card.dashcd.name': 'Dash Capacitor',
  'card.dashcd.desc': 'Dash cooldown -6%',
  'card.greed.name': 'Greed Circuit',
  'card.greed.desc': 'Yellow gem income +8%',
  'card.supershot.name': 'Amplifier',
  'card.supershot.desc': 'Supershot damage +10%',
  'card.focus.name': 'Beam Splitter',
  'card.focus.desc': 'Supershot fan +1 projectile',
  'card.shieldstart.name': 'Phase Shield',
  'card.shieldstart.desc': 'Start every arena with +1 armor unit',
  'card.iframes.name': 'Reactive Plating',
  'card.iframes.desc': 'Invulnerability after taking a hit +15%',
  'card.discount.name': 'Trade License',
  'card.discount.desc': 'Shop card prices -4%',
  'card.luckychip.name': 'Lucky Chip',
  'card.luckychip.desc': 'Reroll price never increases',
  'card.platingdeal.name': 'Plating Deal',
  'card.platingdeal.desc': 'Yellow armor-buy price -25% per copy',
  'card.rerolldiscount.name': 'Reroll Voucher',
  'card.rerolldiscount.desc': 'Reroll price cut: -10% / -25% / -50% per copy',
  'card.cargo.name': 'Cargo Bay',
  'card.cargo.desc': 'Unlock +1 weapon inventory bay',
  'card.glasscannon.name': 'Glass Cannon',
  'card.glasscannon.desc': 'Damage +10%, but invulnerability time -15%',
  'card.glasscannon.up': 'Damage +10%',
  'card.glasscannon.down': 'Invulnerability -15%',
  'card.hairtrigger.name': 'Hair Trigger',
  'card.hairtrigger.desc': 'Fire rate +10%, but range -8%',
  'card.hairtrigger.up': 'Fire rate +10%',
  'card.hairtrigger.down': 'Range -8%',
  'card.heavyplating.name': 'Heavy Plating',
  'card.heavyplating.desc': '+1 armor at every arena start, but speed -7%',
  'card.heavyplating.up': '+1 armor each arena',
  'card.heavyplating.down': 'Speed -7%',
  'card.boosterrig.name': 'Booster Rig',
  'card.boosterrig.desc': 'Speed +10%, but damage -3%',
  'card.boosterrig.up': 'Speed +10%',
  'card.boosterrig.down': 'Damage -3%',
  'card.lootballast.name': 'Loot Ballast',
  'card.lootballast.desc': 'Gem income +18%, but speed -4%',
  'card.lootballast.up': 'Gem income +18%',
  'card.lootballast.down': 'Speed -4%',
  'card.bulwark.name': 'Dampening Field',
  'card.bulwark.desc': 'Incoming hull damage -4%',
  'card.salvager.name': 'Salvage Rig',
  'card.salvager.desc': '+1 armor unit on every boss kill',
  'card.aegislink.name': 'Aegis Link',
  'card.aegislink.desc': 'Damage reduction equal to HALF your damage bonus (max 25%)',
  'card.apex.name': 'Apex Protocol',
  'card.apex.desc': 'Crit chance +5% AND crit damage +25%',
  'card.lifesteal.name': 'Life Drinker',
  'card.lifesteal.desc': '2% of damage dealt returns as hull HP',
  'card.regen.name': 'Nano Swarm',
  'card.regen.desc': 'Repair 25 HP at every arena start',
  'card.speed.name': 'Ion Engine',
  'card.speed.desc': 'Move speed +4%',
  'card.magnet.name': 'Tractor Coil',
  'card.magnet.desc': 'Gem pickup radius +15%',
  'card.energy.name': 'Energy Conduit',
  'card.energy.desc': 'Supershot energy per hit +1',
  'card.heart.name': 'Hull Cell',
  'card.heart.desc': '+25 max HP (one battery cell, charged)',
  'card.barrel.name': 'Gun Mount Tier',
  'card.barrel.desc': 'Mount tier +1: nose → wings → wings+nose → top supershot cannon',
  'card.rack.name': 'Weapon Rack',
  'card.rack.desc': '+1 weapon socket (max 3) — all fire together, on their own reloads',
  'card.ghostdash.name': 'Ghost Dash',
  'card.ghostdash.desc': 'Dash invulnerability +0.25s — phase through bullets',
  'card.superfan.name': 'Overload',
  'card.superfan.desc': 'Supershot fan +2 projectiles',
  'card.overcharge.name': 'War Core',
  'card.overcharge.desc': 'All damage +12%',
} as const;
